import { Box, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ChevronRight } from "lucide-react";
import { H5 } from "components/Typography";
import { useTheme } from "@mui/material/styles";
const ModernPanelContainer = styled(Box)({
  position: "absolute",
  top: "100%",
  left: 0,
  width: "100%",
  backgroundColor: "#fff",
  padding: "16px 0 10px 0",
  borderRadius: "0 0 16px 16px",
  zIndex: 1202,
  display: "flex",
  justifyContent: "center",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
});

const ModernMenuGrid = styled(Grid)({
  maxWidth: "1200px",
  width: "100%",
  margin: "0 auto",
});

const MenuCategory = styled(Box)(({ theme }) => ({
  marginBottom: "24px",
}));

const CategoryTitle = styled(H5)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: "16px",
  fontWeight: 600,
  fontSize: "0.875rem",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
}));

const MenuLink = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  padding: "8px 0",
  fontSize: "0.9375rem",
  transition: "all 0.2s ease",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  "&:hover": {
    color: theme.palette.primary.darkBlue,
    transform: "translateX(4px)",
  },
}));

const ModernMenuPanel = ({
  menus,
  isMenuActive,
  handleMenuClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  const theme = useTheme();

  return (
    <ModernPanelContainer
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <ModernMenuGrid container spacing={2} gap={3}>
        {menus.map((menu, index) => (
          <Grid item xs={12} sm={6} md={2} key={index}>
            <MenuCategory>
              <CategoryTitle>{menu.name}</CategoryTitle>
              {menu.menus.map((subMenu, subIndex) => (
                <MenuLink
                  key={subIndex}
                  onClick={() => handleMenuClick(subMenu.url)}
                  sx={{
                    color: isMenuActive(subMenu.url)
                      ? theme.palette.primary.darkBlue
                      : "text.primary",
                  }}
                >
                  {subMenu.name}
                  {/* {subMenu.children?.length > 0 && (
                    <ChevronRight
                      size={16}
                      style={{
                        marginLeft: "auto",
                        opacity: 0.5,
                      }}
                    />
                  )} */}
                </MenuLink>
              ))}
            </MenuCategory>
          </Grid>
        ))}
      </ModernMenuGrid>
    </ModernPanelContainer>
  );
};

export default ModernMenuPanel;
